import React, { useState } from 'react';

export default function WorkflowTimeline({ activities = [], comments = [], onRead }) {
  const [tab, setTab] = useState('notifications');
  if (!Array.isArray(activities) || activities.length === 0) return null;

  const formatDate = (iso) => {
    if (!iso) return '';
    try {
      const d = new Date(iso);
      const dd = String(d.getDate()).padStart(2, '0');
      const mm = String(d.getMonth() + 1).padStart(2, '0');
      const yyyy = d.getFullYear();
      const hh = String(d.getHours()).padStart(2, '0');
      const mn = String(d.getMinutes()).padStart(2, '0');
      return `${dd}/${mm}/${yyyy} à ${hh}:${mn}`;
    } catch {
      return iso;
    }
  };

  const labelByState = {
    submitted: "Le rapport a été soumis",
    transmitted_to_igf: "Le rapport a été transmis à l'IGF",
    // ... (ajoute d’autres états si besoin)
  };

  const isComment = (it) => {
    if (!it || typeof it !== 'object') return false;
    if ('created_at' in it) return true; // shape fourni par ton JSON
    if (it.type && String(it.type).toLowerCase() === 'comment') return true;
    // fallback: items with a message but without a workflow state -> consider them commentaires
    if (it.message && !it.state) return true;
    return false;
  };

  const getCreatedAt = (it) => it.created_at ?? it.createdAt ?? it.createdAt ?? '';
  const getMessage = (it) => it.message ?? it.msg ?? it.body ?? '';
  const getAuthor = (it) =>
    it.createdBy?.name || it.created_by?.name || it.user?.name || '';
  
  const notifications = activities
    .filter((a) => !isComment(a))
    .slice()
    .sort((a, b) => new Date(b.createdAt ?? b.created_at) - new Date(a.createdAt ?? a.created_at));

  const renderList = (items, asComments = false) => (
    <ul className="list-unstyled m-0">
      {items.map((act) => {
        const date = formatDate(getCreatedAt(act));
        const title = asComments ? 'Commentaire' : (labelByState[act.state] || act.message || '');
        const content = asComments ? getMessage(act) : (act.message || act.note || '');
        const author = getAuthor(act);
        return (
          <li key={act.id ?? `${asComments ? 'c' : 'n'}-${date}-${Math.random()}`} className="mb-3 d-flex">
            <div
              style={{
                width: 10,
                height: 10,
                borderRadius: 10,
                background: asComments ? '#007bff' : '#28a745',
                marginTop: 6,
                marginRight: 12,
              }}
            />
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 12, color: '#6c757d' }}>{date}</div>
              {/* <div style={{ fontWeight: 600 }}>{title}</div> */}
              <div style={{ fontWeight: 600 }}>{content ? <div style={{ marginTop: 4, color: '#212529' }} dangerouslySetInnerHTML={{ __html: content }} /> : null}</div>
              {/* {author ? <div style={{ fontSize: 12, color: '#6c757d', marginTop: 6 }}>Par {author}</div> : null} */}
              {act?.file ? <div style={{ marginTop: 6 }}><a href="javascript:void()" onClick={()=>onRead?.(act?.file?.url)} rel="noopener noreferrer">Fichier associé</a></div> : null}
            </div>
          </li>
        );
      })}
    </ul>
  );

  return (
    <aside className="card" style={{ border: '1px solid #e9ecef', borderRadius: '10px' }}>
      <div className="card-header p-0" style={{ background: '#f8f9fa', fontWeight: 600, borderRadius: '10px 10px 0 0', padding: "0 !important" }}>
        <ul className="nav nav-tabs" style={{marginBottom: " 0 !important" }}>
          <li className="nav-item">
            <button type="button" className={`nav-link ${tab === 'notifications' ? 'active' : ''}`} onClick={() => setTab('notifications')}>
              Notifications ({notifications.length})
            </button>
          </li>
          <li className="nav-item">
            <button type="button" className={`nav-link ${tab === 'comments' ? 'active' : ''}`} onClick={() => setTab('comments')}>
              Commentaires ({comments.length})
            </button>
          </li>
        </ul>
      </div>

      <div className="card-body" style={{ maxHeight: 520, overflowY: 'auto' }}>
        {tab === 'notifications' && renderList(notifications, false)}
        {tab === 'comments' && renderList(comments, true)}
      </div>
    </aside>
  );
}
